module.exports = __webpack_public_path__ + "static/media/Logo-Projectim_rvb.98207c3d.jpg";